module.exports = __webpack_public_path__ + "static/media/Signature.0688d3bb.webp";